module.exports = __webpack_public_path__ + "Server-Healthy.AzureSubscription.4b28c694b50b0177851575b3dfe25f47.hashedasset.svg";